module.exports = __webpack_public_path__ + "static/media/gaydon-lighthorne-heath.84a4a544.jpg";